import React, { useEffect } from "react";

export const ExportacaoTimsheetTemplate = ({ timesheet, timesheetAtividade, timesheetGrupoAtividade, showPdf = false }) => {




    const timesheetAtividadeParam = JSON.parse(JSON.stringify(timesheetAtividade));

    if (timesheetAtividadeParam?.itens?.length > 0) {
        const parseDate = (dateString) => {
            var parts = dateString.split("/");
            return new Date(parts[2], parts[1] - 1, parts[0]);
        }

        const parseTime = (timeString) => {
            var timeParts = timeString.split(":");
            return parseInt(timeParts[0]) * 60 + parseInt(timeParts[1]);
        }


        timesheetAtividadeParam?.itens.sort((a, b) => {
            var dateA = parseDate(a.datalancamento);
            var dateB = parseDate(b.datalancamento);
            if (dateA.getTime() === dateB.getTime()) {
                var timeA = parseTime(a.periodoInicio);
                var timeB = parseTime(b.periodoInicio);
                return timeA - timeB;
            }
            return dateA - dateB;
        });

    }


    const convertDecimalToTime = (decValue) => {
        if (!decValue) {
            return;
        }

        const decimalHours = parseFloat(decValue?.replace(',', '.'));
        const hours = Math.floor(decimalHours);
        const minutes = Math.round((decimalHours - hours) * 60);
        const formattedHours = String(hours).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');

        return `${formattedHours}:${formattedMinutes}`;
    }


    const checkisCRT = () => {
        const patern = /(\d{4})([R])/gi;
        return patern.test(timesheet?.pericia?.sigla) || patern.test(timesheet?.regulacao?.sigla);
    };
    const colorHeadTable = checkisCRT() ? '#0070b6' : '#2c3b82';
    const empresaNome = checkisCRT() ? 'CRT Adjusters' : 'Critério Experts';

    return (
        <div style={showPdf ? {} : { zIndex: 99999, position: "absolute", left: '-10000px' }}>
            {/* <div> */}
            {/* <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1 }}>
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%) rotate(-45deg)', opacity: 0.2, fontSize: 24, color: '#CCCCCC' }}>Confidencial</div>
            </div> */}
            <div className="export-pdf" style={{ fontSize: '13px' }}>
                <div className="header">
                    <table className="table table-bordered table-width" id="my-table-header" style={{ background: "#fff" }}>
                        <tbody>
                            <tr style={{ border: "none" }}>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }}>
                                    <b style={{ color: "#000" }}>Seguradora:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.cliente?.clienteNome}
                                    </p>
                                </td>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }} colSpan="2">
                                    <b style={{ color: "#000" }}>Apólice:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.sinistro?.numeroApolice}
                                    </p>
                                </td>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }}>
                                    <b style={{ color: "#000" }}>Laudo:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.pericia?.sigla}
                                    </p>
                                </td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }}>
                                    <b style={{ color: "#000" }}>Segurado:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.segurado?.seguradoNome}
                                    </p>
                                </td>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }} colSpan="2">
                                    <b style={{ color: "#000" }}>Sinistro:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.sinistro?.numeroSinistro}
                                    </p>
                                </td>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }}>
                                    <b style={{ color: "#000" }}>TS:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.timesheet?.numeroTimesheet.replace("TS", "")} | {timesheet?.timesheet?.tipoTimesheet}
                                    </p>
                                </td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }}>


                                    <b style={{ color: "#000" }}>Nº do Processo:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.sinistro?.numeroProcessoJudicial}
                                    </p>
                                </td>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }} colSpan="2">
                                     <b style={{ color: "#000" }}>Nº do Aviso:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.sinistro?.numeroAviso}
                                    </p>
                                </td>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }}>
                                    <b style={{ color: "#000" }}>Nº ISJ:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.sinistro?.numeroISJ}
                                    </p>
                                </td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }}>
                                    <b style={{ color: "#000" }}>Local:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.sinistro?.local}
                                    </p>
                                </td>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }}>
                                    <b style={{ color: "#000" }}>U.N:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.disciplina?.seguradoNome}
                                    </p>
                                </td>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }}>
                                    <b style={{ color: "#000" }}>Horas:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.timesheet?.totalHoras}
                                    </p>
                                </td>
                                <td className="text-center" style={{ border: '1px solid #000', padding: '0' }}>
                                    <b style={{ color: "#000" }}>Total:  </b>
                                    <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                        {timesheet?.timesheet?.totalValor}
                                    </p>
                                </td>
                            </tr>
                            {
                                timesheet?.descontoComercial != null && timesheet?.descontoComercial?.valorTotalDesconto != "R$ 0,00" && (
                                    <>
                                        <tr style={{ border: "none" }} colSpan="6">
                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0', lineHeight: "40px" }} rowSpan={2} colSpan={3}>
                                                <b style={{ color: "#eb0000" }}>Obs:  </b>
                                                <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                                    Para o Timesheet em questão, foi concedido pela {empresaNome} desconto comercial à {timesheet?.cliente?.clienteNome}
                                                </p>
                                            </td>
                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0' }} colSpan={1}>
                                                <b style={{ color: "#000" }}>Desconto Comercial:  </b>
                                                <p style={{ color: '#eb0000', display: 'inline', fontWeight: 'bold' }}>
                                                    {timesheet?.descontoComercial?.valorTotalDesconto}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr style={{ border: "none" }}>
                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0' }} colSpan={1}>
                                                <b style={{ color: "#000" }}>Valor Total:  </b>
                                                <p style={{ color: '#2c3b82', display: 'inline', fontWeight: 'bold' }}>
                                                    {timesheet?.descontoComercial?.valorTotalGeralFaturado}
                                                </p>
                                            </td>
                                        </tr>
                                    </>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            <div>
                <div className="export-pdf" style={{ fontSize: '13px' }} >
                    <div className="header atividades">
                        <table className="table table-bordered table-width" id="my-table" style={{ background: "#fff" }}>
                            <thead>
                                <tr className="table-legend-info">
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff", border: '1px solid #000' }}>
                                        Profissional
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff", border: '1px solid #000' }}>
                                        Data
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff", border: '1px solid #000' }}>
                                        Atividades Desenvolvidas em Campo e Escritório
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff", border: '1px solid #000' }}>
                                        Início
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff", border: '1px solid #000' }}>
                                        Término
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff", border: '1px solid #000' }}>
                                        Intervalo
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff", border: '1px solid #000' }}>
                                        Valor/Hora
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff", border: '1px solid #000' }}>
                                        Base
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff", border: '1px solid #000', width: '130px' }}>
                                        Total
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {timesheetAtividadeParam?.itens?.filter(a=> !a.proBono).map((atividade, index) => {
                                    return (
                                        <tr key={atividade?.idTimesheetItemAtividade}>
                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                {atividade.peritoNome}
                                            </td>
                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                {atividade.datalancamento}
                                            </td>
                                            <td className="text-left" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                {atividade.atividade} {atividade?.descricao && ' - ' + atividade.descricao}
                                            </td>
                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                {atividade.periodoInicio}
                                            </td>
                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                {atividade.periodoFim}
                                            </td>
                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                {atividade.intervaloHoras == "" ? "00:00" : convertDecimalToTime(atividade.intervaloHoras)}
                                            </td>
                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                {atividade.valorHoraBase}
                                            </td>
                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                {atividade.baseHoras}
                                            </td>
                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px', width: '130px' }}>
                                                {atividade.totalValorFaturado}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div key={'divTableGrupoAtividades'} className="header">
                        <table key={'tableGrupoAtividades'} className="table table-bordered table-width" id="my-table-grupo" style={{ background: "#fff" }}>
                            <thead key={'tableGrupoAtividadesThead'}>
                                <tr className="table-legend-info">
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff" }}>
                                        Profissional
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff" }}>
                                        Periodo
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff" }}>
                                        Outras Atividades
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff" }}>
                                        Quantidade
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff" }}>
                                        Valor/Hora
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff" }}>
                                        Horas
                                    </th>
                                    <th className="text-center" style={{ background: colorHeadTable, color: "#fff" }}>
                                        Total
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {timesheetGrupoAtividade?.itens?.map((item, index) => {

                                    var countAtividadeMerge = item.Value.filter((atividadeGrupo) => atividadeGrupo.totalValorFaturado > 0).length;
                                    var countAtividade = 0;
                                    return (
                                        <>
                                            {item.Value.map((atividadeGrupo, index) => {
                                                if (atividadeGrupo.totalValorFaturado > 0) {
                                                    countAtividade++;
                                                    return (
                                                        <tr key={'trGrupoAt' + countAtividade + index} style={{ border: "none" }}>
                                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                                {atividadeGrupo?.peritoNome}
                                                            </td>
                                                            {countAtividade === 1 &&
                                                                <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px', verticalAlign: 'middle' }} rowSpan={countAtividadeMerge}>
                                                                    {item.Value[0].periodoInicio} a {item.Value[0].periodoFim}
                                                                </td>
                                                            }
                                                            <td className="text-left" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                                {atividadeGrupo?.atividade} {atividadeGrupo?.descricao && ' - ' + atividadeGrupo.descricao}
                                                            </td>
                                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                                {atividadeGrupo?.idGrupoAtividade == 3 || atividadeGrupo?.idGrupoAtividade == 4 ? '-' : atividadeGrupo?.horasExecutadas}
                                                            </td>
                                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                                {atividadeGrupo?.valorHoraBaseFormat}
                                                            </td>
                                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                                {atividadeGrupo?.idGrupoAtividade != 3 && atividadeGrupo?.idGrupoAtividade != 4 ? atividadeGrupo?.horaCoeficiente : atividadeGrupo?.horasExecutadas}
                                                            </td>
                                                            <td className="text-center" style={{ border: '1px solid #000', padding: '0px 8px' }}>
                                                                {atividadeGrupo?.totalValorFaturadoFormat}
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            })}
                                        </>
                                    )
                                }
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
